import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


import reportWebVitals from './reportWebVitals';
import App from './App';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
